import { Avatar, Menu, Stack, Text, UnstyledButton } from '@mantine/core';
import { IconChevronRight, IconEdit, IconLogout, IconUserCircle } from '@tabler/icons-react';

import { useAuthFlow } from '@/shared/auth';

import styles from './Profile.module.css';
import { useCurrentProductRoles } from './roles';
import { useUserInfo } from './useUserInfo';

export function Profile() {
  const { signoutRedirect } = useAuthFlow();
  const { name, email, initials } = useUserInfo();
  const workspaceRoles = useCurrentProductRoles();

  return (
    <Menu
      position="right-end"
      width={220}
      withArrow
      offset={16}
    >
      <Menu.Target>
        <UnstyledButton className={styles.root}>
          <Avatar
            classNames={{
              placeholder: styles.avatarPlaceholder,
            }}
            color="dark.9"
            radius="xl"
            size={36}
            variant="filled"
          >
            {initials}
          </Avatar>

          <Stack gap={0} className={styles.credentials}>
            <Text lh="sm" fz="sm" className={styles.name}>{name}</Text>
            <Text c="dimmed" lh="xs" fz="xs" className={styles.email}>{email}</Text>
          </Stack>

          <IconChevronRight stroke={2} size={16} />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        {workspaceRoles.length > 0 && (
          <>
            <Menu.Label>Apps & Roles</Menu.Label>
            {workspaceRoles.map(role => (
              <Menu.Item key={role.id} disabled leftSection={<IconUserCircle size={20} stroke={1.5} />}>
                {role.name}
              </Menu.Item>
            ))}
            <Menu.Divider />
          </>
        )}

        <Menu.Label>Account</Menu.Label>
        <Menu.Item
          leftSection={<IconEdit size={20} stroke={1.5} />}
          component="a"
          href={process.env.PUBLIC_SELF_SERVICE_URL}
          target="_blank"
        >
          Manage account
        </Menu.Item>
        <Menu.Item
          leftSection={<IconLogout size={20} stroke={1.5} />}
          onClick={() => signoutRedirect()}
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
